import { render, staticRenderFns } from "./UpsFacturas.vue?vue&type=template&id=43bc6ebf&"
import script from "./UpsFacturas.vue?vue&type=script&lang=js&"
export * from "./UpsFacturas.vue?vue&type=script&lang=js&"
import style0 from "./UpsFacturas.vue?vue&type=style&index=0&id=43bc6ebf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports